export class PlaybackError extends Error {
    name = 'PlaybackError';
    code;
    constructor(code, message) {
        super(message);
        this.code = code;
    }
}
export const isPlaybackError = (error) => {
    return error instanceof PlaybackError;
};
